import React from "react";
import ErrorMessage from "./ErrorMessage";
import { getLabel } from "../InitData";

export default function ErrorMessageWithLink() {
    return (
        <ErrorMessage text={getLabel('general.error')} />
    );
}
